import getAPIPath from '../modules/api-location';

window.checkExistsFolderService = function (userId, title, folderId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/user/folder`,
    type: 'get',
    data: {
      user_id: userId,
      title,
      folder_id: folderId,
    },
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
  });
};

window.createFolderService = function (data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/user/folder`,
    type: 'post',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },
  });
};

window.renameFolderService = function (data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/user/folder`,
    type: 'put',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.deleteFolderService = function (userId, folderId, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/user/folder?user_id=${userId}&folder_id=${folderId}`,
    type: 'delete',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.addContentToFolderService = function (data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/user/folder/content`,
    type: 'put',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.deleteContentFromFolderService = function (folderId, contentId, contentType, successFn) {
  return $.ajax({
    url: `${getAPIPath}queryapi/user/folder/content?folder_id=${folderId}&content_id=${contentId}&content_type=${contentType}`,
    type: 'delete',
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};


window.shareAFolderService = function(data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/user/folder/share`,
    type: 'put',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};

window.updateFolderTeamIDListService = function(data, successFn) {
  return $.ajax({
    url: `${getAPIPath}commandapi/user/folder/team`,
    type: 'post',
    data,
    success: successFn,
    async: true,
    dataType: 'json',
    xhrFields: {
      withCredentials: true,
    },

  });
};






// WEBPACK FOOTER //
// ./library/js/services/folder.service.js